import Icon from "@mui/icons-material/Category";
import FmbContributionCategoryCreate from "./FmbContributionCategoryCreate";
import FmbContributionCategoryEdit from "./FmbContributionCategoryEdit";
import FmbContributionCategoryList from "./FmbContributionCategoryList";

export default {
  name: "fmbContributionCategory",
  list: FmbContributionCategoryList,
  create: FmbContributionCategoryCreate,
  edit: FmbContributionCategoryEdit,
  icon: Icon,
  label: "Contribution categories",
  options: { label: "Contribution categories" },
};
